import {
    DISCONNECT_WEBCHAT,
    DISCONNECT_WEBCHAT_FAILED,
    DISCONNECT_WEBCHAT_SUCCESS,
} from './constants';

/**
 * Create an action of type DISCONNECT_WEBCHAT_MESSAGE
 *
 * @export {function} sendWebchatMessage
 * @returns {Object} - Action of type DISCONNECT_WEBCHAT_MESSAGE
 */
export function disconnect () {
    return {
        type: DISCONNECT_WEBCHAT,
    };
}

/**
 * Create an action of type DISCONNECT_WEBCHAT_MESSAGE_SUCCESS
 *
 * @export {function} sendWebchatMessageSuccess
 * @returns {Object} - Action of type DISCONNECT_WEBCHAT_MESSAGE_SUCCESS and the API data payload
 */
export function disconnectWebchatSuccess (response) {
    return {
        type: DISCONNECT_WEBCHAT_SUCCESS,
        response,
    };
}

/**
 * Create an action of type DISCONNECT_WEBCHAT_MESSAGE_FAILED
 *
 * @export {function} sendWebchatMessageFailed
 * @returns {Object} - Action of type DISCONNECT_WEBCHAT_MESSAGE_FAILED and the API data payload
 */
export function disconnectWebchatFailed (error, errorCode) {
    return {
        type: DISCONNECT_WEBCHAT_FAILED,
        error,
        errorCode,
    };
}
